/**
 * Copyright (c) 2024 TechDivision GmbH
 * All rights reserved
 *
 * This product includes proprietary software developed at TechDivision GmbH, Germany
 * For more information see https://www.techdivision.com/
 *
 * To obtain a valid license for using this software please contact us at
 * license@techdivision.com
 *
 * @author Dominik Böck <d.boeck@techdivision.com>
 */

import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useFormikContext } from 'formik';
import { ContractVolumeInformation } from '../../ContractForm/ChildComponents/ContractVolumeInformation';

/**
 * ContractVolumeInformationPreview Component
 * @returns {JSX.Element}
 * @constructor
 */
export function ContractVolumeInformationPreview() {
  const { t } = useTranslation('translations');
  const {
    values: { contractVolumeInformation },
  } = useFormikContext();
  if (!contractVolumeInformation) {
    return null;
  }

  return (
    <Grid container mt={4}>
      <Grid item xs={12}>
        <Typography
          sx={{
            fontWeight: 'bold',
            letterSpacing: '1px',
            textTransform: 'uppercase',
            color: '#49ad33',
          }}
        >
          {t('newContractVolumeInformation')}
        </Typography>
        <Box mt={2}>
          <Box
            sx={{
              backgroundColor: 'rgba(73,173,51,0.2)',
              padding: '12px',
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <ContractVolumeInformation
              contractVolumeInformation={contractVolumeInformation?.value}
              newContractVolumeInformation={contractVolumeInformation?.newValue}
            />
          </Box>
        </Box>
      </Grid>
    </Grid>

  );
}
